export const translate = (t, translationKeyAndOptions) => {
    // i18next types `t` against the consuming app's declared resource bundles,
    // which this product-agnostic kit deliberately knows nothing about. The key
    // was validated by the product's own key typing before it was branded, so the
    // casts bridge a gap the kit cannot prove rather than skip a check.
    return t(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
    translationKeyAndOptions.translationKey, 
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
    translationKeyAndOptions.translationOptions);
};
/**
 * Overloaded function to build a translation.
 */
export function buildTranslationInput(translationInput, context) {
    if (translationInput === undefined) {
        return undefined;
    }
    if (typeof translationInput === "function") {
        // Context is guaranteed by the overload signatures when translationInput
        // is a function, so the cast is safe.
        const result = translationInput(context);
        return typeof result === "object"
            ? result
            : { translationKey: result, translationOptions: undefined };
    }
    if (typeof translationInput === "object") {
        return translationInput;
    }
    return { translationKey: translationInput, translationOptions: undefined };
}
//# sourceMappingURL=translationKit.js.map